import { Box, Button, CircularProgress, Typography } from '@mui/material'
import useStyles, { buttonSx } from './_styles'
import { ArrowBackwardIcon, ArrowForwardIosIcon } from '../../../assets/icons/icons'
import { PlannedExpertiseBottomBarProps } from './_props'
import { getCivilityLabel, getPatientBirthLabel } from '../../Patient/History/_utils'

export default function PlannedExpertiseBottomBar({
    recap,
    onBack,
    showBack = true,
    backDisabled = false,
    backLoading = false,
    onNext,
    showSkip = false,
    onSkip,
    skipReplacesNext = false,
    skipLoading = false,
    canGoNext = true,
    goNextLabel = 'Suivant',
    skipLabel = 'Passer',
}: PlannedExpertiseBottomBarProps) {
    const classes = useStyles()

    const getDisplayInfo = () => {
        if (!recap) {
            return {
                patientName: 'Patient',
                destination: '—',
            }
        }
        const sex = recap.patientSex
        const civility = getCivilityLabel(sex)
        const birthLabel = getPatientBirthLabel(sex)
        const fullName = (recap.patientFullName || 'Patient').replace(
            /\(né(?:e|\(e\))?(?=\s)/i,
            `(${birthLabel.toLowerCase()}`,
        )
        const destination = recap.requiredExpertLabel || '—'
        return {
            patientName: `${civility ? `${civility} ` : ''}${fullName}`,
            destination,
        }
    }

    const displayInfo = getDisplayInfo()

    return (
        <Box className={classes.bottomBar}>
            <Box className={classes.leftSection}>
                <Typography className={classes.patientInfo}>
                    Pour {displayInfo.patientName} - À destination de {displayInfo.destination}
                </Typography>
            </Box>

            <Box className={classes.rightSection}>
                {onBack && showBack && (
                    <Button
                        onClick={onBack}
                        variant="outlined"
                        className={classes.backButton}
                        disabled={backDisabled || backLoading}
                        startIcon={backLoading ? <CircularProgress size={16} color="inherit" /> : <ArrowBackwardIcon />}
                    >
                        Retour
                    </Button>
                )}
                {showSkip && !skipReplacesNext && (
                    <Button
                        onClick={onSkip}
                        variant="contained"
                        className={classes.nextButton}
                        sx={buttonSx.secondaryButton}
                        disabled={skipLoading}
                    >
                        {skipLabel}
                    </Button>
                )}
                {showSkip && skipReplacesNext ? (
                    <Button
                        onClick={onSkip}
                        variant="contained"
                        className={classes.nextButton}
                        disabled={skipLoading}
                        endIcon={skipLoading ? <CircularProgress size={16} color="inherit" /> : <ArrowForwardIosIcon />}
                    >
                        {skipLabel}
                    </Button>
                ) : (
                    <Button
                        onClick={onNext}
                        variant="contained"
                        className={classes.nextButton}
                        endIcon={<ArrowForwardIosIcon />}
                        disabled={!canGoNext}
                    >
                        {goNextLabel}
                    </Button>
                )}
            </Box>
        </Box>
    )
}
